import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

@Pipe({
  name: 'colon',
})
@Injectable({
  providedIn: 'root',
})
export class ColonPipe implements PipeTransform {
  constructor(private transloco: TranslocoService) {}

  transform(value: string): string {
    return `${value}${this.colonTranslation}`;
  }

  get colonTranslation(): string {
    let colon = '';
    this.transloco
      .selectTranslate('GLOBAL.COLON')
      .subscribe((translation) => (colon = translation));
    return colon;
  }
}
